import { ModalWindow, JsonViewer, Button, TableBuilder } from "@tblabs/truffle";
import { PrimaryButton } from "../Components/PrimaryButton";
import { DangerButton } from "../Components/DangerButton";
import { ConnectionStatus } from "../Models/DeviceConnectionStatus";
import { MessageToWatchersWindow } from "./MessageToWatchersWindow";
import { Device } from "../Services/Device";


export class DeviceWatchersWindow extends ModalWindow
{
    constructor(device: Device)
    {
        super(`👀 ${device.Id} Watchers`, true, true, true);

        this.AddContent(
            new TableBuilder(device.Watchers)
                .AddColumn("Id", watcher => (watcher.Status == ConnectionStatus.Connected ? "🟢" : "⚪") + " " + watcher.Id)
                .AddColumn("Info", watcher => new JsonViewer(watcher.Info, "Fingerprint", { foldAll: true, typePrinter: (t) => "", copyValueIcon: "" }))
                .AddColumn("Options", watcher => [
                    new DangerButton("👟 Kick", () =>
                    {
                        if (confirm(`Kick only breaks socket session. User can login again (until password change)! Still wanna kick ${watcher.Id}?`))
                        {
                            device.KickWatcher(watcher.Id);
                        }
                    }),
                    new PrimaryButton("💌 Message", () => new MessageToWatchersWindow(device, watcher)),
                ])
                .Build(),
        );
        this.AddToFooter(
            new Button("Close", () => this.CloseWindow()),
        )

        this.OpenWindow();
    }
}
